module.exports = __webpack_public_path__ + "static/img/aa.93720bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aa.jpg
// module id = RH8/
// module chunks = 1